/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsSettingsReviewCycleMode_goal = {
    readonly id: string;
    readonly type: GoalType;
    readonly reviewMode: {
        readonly spacedRepetition: boolean;
        readonly cycleBegin: {
            readonly days: number | null;
            readonly months: number | null;
        };
        readonly cycleGoal: {
            readonly days: number | null;
            readonly months: number | null;
        } | null;
    };
    readonly " $refType": "GoalDetailsSettingsReviewCycleMode_goal";
};
export type GoalDetailsSettingsReviewCycleMode_goal$data = GoalDetailsSettingsReviewCycleMode_goal;
export type GoalDetailsSettingsReviewCycleMode_goal$key = {
    readonly " $data"?: GoalDetailsSettingsReviewCycleMode_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsSettingsReviewCycleMode_goal">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "days",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "months",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsSettingsReviewCycleMode_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewMode",
      "kind": "LinkedField",
      "name": "reviewMode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spacedRepetition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleBegin",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleGoal",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
})();
(node as any).hash = 'dfdfe0917a25a12b461219a363e03566';
export default node;
